// extracted by css-extract-rspack-plugin
export default {"root":"HuD3M7","icon":"TA2Jb0"};